import * as tslib_1 from "tslib";
import { selectSubcategory } from 'owa-options-orchestration';
import { getStore } from 'owa-options-store';
import { observer } from 'mobx-react';
import { BaseButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { AnimationClassNames } from '@uifabric/styling';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
var styles = require('./OptionsFull.scss');
var className = require('classnames/bind').bind(styles);
var SubCategoryEntry = observer(function (props) {
    var buttonStyles = {
        root: className(styles.option, {
            selectedOption: getStore().currentSubCategoryKey === props.subcategory.key,
        }),
        flexContainer: styles.optionFlexContainer,
        label: styles.optionLabel,
    };
    return (React.createElement(BaseButton, { styles: buttonStyles, key: props.subcategory.key, onClick: function () { return selectSubcategory(props.subcategory); }, text: strings[props.subcategory.titleStringKey] }));
});
var SubCategoriesColumn = /** @class */ (function (_super) {
    tslib_1.__extends(SubCategoriesColumn, _super);
    function SubCategoriesColumn() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubCategoriesColumn.prototype.render = function () {
        return (React.createElement("div", { className: styles.optionsColumn },
            React.createElement(FocusZone, { direction: FocusZoneDirection.vertical, key: getStore().currentCategoryKey, className: AnimationClassNames.slideLeftIn20 }, this.props.subcategories.map(function (subcategory) { return (React.createElement(SubCategoryEntry, { subcategory: subcategory, key: subcategory.key })); }))));
    };
    SubCategoriesColumn = tslib_1.__decorate([
        observer
    ], SubCategoriesColumn);
    return SubCategoriesColumn;
}(React.Component));
export default SubCategoriesColumn;
//# sourceMappingURL=SubCategoriesColumn.js.map